import { render } from "./InstructionView.vue?vue&type=template&id=0d57018f"
import script from "./InstructionView.vue?vue&type=script&lang=js"
export * from "./InstructionView.vue?vue&type=script&lang=js"

import "./InstructionView.vue?vue&type=style&index=0&id=0d57018f&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__